import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDesignMode } from "../DesignModeContext";
import "./Menu.css";

const Menu = () => {
  const [menuLink, setMenuLink] = useState("Menu-Link-Hidden");
  const [show, setShow] = useState(false);
  const { isDesignMode, toggleDesignMode } = useDesignMode();

  const wakeApi = async () => {
    // Double-check we're not in design mode
    if (isDesignMode) {
      return;
    }
    
    try {
      await axios({
        url: "https://api.caigoycreations.com/products/getproducts",
        method: "get",
        timeout: 5000
      });
    } catch (error) {
      // Silently fail - this is expected when API is not available
      console.log("API not available (normal in Design Mode or if backend is down)");
    }
  };

  const ShowMenu = () => {
    if (show) {
      setShow(false);
      setMenuLink("Menu-Link-Hidden");
    } else {
      setShow(true);
      setMenuLink("Menu-Link");
    }
  };

  const checkStyle = () => {
    if (show) {
      if (document.body.clientWidth > 600) {
        setShow(false);
        setMenuLink("Menu-Link-Hidden");
      }
    }
  };

  useEffect(() => {
    // Only wake API if not in design mode
    if (!isDesignMode) {
      wakeApi().catch(err => {
        // Silently catch any errors from API wake call
        console.log("API wake skipped:", err.message);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesignMode]);

  useEffect(() => {
    window.addEventListener("resize", checkStyle);
    return () => {
      window.removeEventListener("resize", checkStyle);
    };
  }, [show]);

  const handleLinkClick = () => {
    setMenuLink('Menu-Link-Hidden');
    if (!isDesignMode) {
      wakeApi().catch(err => {
        console.log("API wake skipped:", err.message);
      });
    }
  };

  return (
    <div className="Menu" id="Menu">
      <div className='LogoPanel'>
        <Link to="/" className="Logo-Text" onClick={() => setMenuLink('Menu-Link-Hidden')}>
          <span className="logo-text-brand">Caigoy</span>
          <span className="logo-text-secondary">Creations</span>
        </Link>

        <div className='LoginButton'>
          <div className="mode-toggle-container">
            <label className="mode-toggle-label">
              <span className={isDesignMode ? "mode-active" : ""}>Design</span>
              <div className="toggle-switch" onClick={toggleDesignMode}>
                <div className={`toggle-slider ${isDesignMode ? 'design' : 'live'}`}></div>
              </div>
              <span className={!isDesignMode ? "mode-active" : ""}>Live</span>
            </label>
          </div>
        </div>
      </div>

      <div className='SubMenu'>
        <div className="Menu-Navigation">
          <div className="Hamburger" onClick={() => ShowMenu()}>
            <i className="fas fa-bars fa-lg"></i>
          </div>

          <Link to="/" className={menuLink} onClick={handleLinkClick}>
            HOME
          </Link>
          <Link
            to="/About-Us"
            className={menuLink}
            style={{ minWidth: "87px" }}
            onClick={handleLinkClick}
          >
            ABOUT US
          </Link>

          <Link to="/Products" className={menuLink} onClick={handleLinkClick} replace>
            PRODUCTS
          </Link>

          <Link
            exactPath
            to="/Products/Create"
            className={menuLink}
            style={{ minWidth: "170px" }}
            onClick={handleLinkClick}
          >
            CREATE PRODUCT
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Menu;
